import { observable, action } from "mobx";
import uuidv4 from "uuid/v4";

class ToastMessageStore {
  /**
   * @type {int|null}
   */
  @observable showTimeout = 100;

  /**
   * @type {int|null}
   */
  @observable hideTimeout = 5000;

  /**
   * @type {Array}
   */
  @observable toastMessages = [];

  @action
  addToastMessage(message, type = "positive", header = null) {
    if (!message) {
      throw new Error("A message is required. If you need to clear it call removeToastMessage() instead.");
    }

    const newToastMessageId = uuidv4();

    this.toastMessages.push({
      id: newToastMessageId,
      message,
      header,
      type,
      showTimer: setTimeout(() => this.showToastMessage(newToastMessageId), this.showTimeout),
      hideTimer: setTimeout(() => this.hideToastMessage(newToastMessageId), this.showTimeout + this.hideTimeout),
      visible: false,
    });
  }

  @action
  showToastMessage(toastMessageId) {
    const foundIndex = this.toastMessages.findIndex(item => item.id === toastMessageId);

    if (foundIndex === -1) {
      return;
    }

    clearTimeout(this.toastMessages[foundIndex].timer);

    this.toastMessages[foundIndex].visible = true;
  }

  @action
  hideToastMessage(toastMessageId) {
    const foundIndex = this.toastMessages.findIndex(item => item.id === toastMessageId);

    if (foundIndex === -1) {
      return;
    }

    clearTimeout(this.toastMessages[foundIndex].timer);

    this.toastMessages[foundIndex].visible = false;
  }

  @action
  setTimeout(timeout) {
    this.timeout = timeout;
  }

  @action
  addChangesSavedToastMessage() {
    this.addToastMessage("Changes saved", "positive", "Success");
  }
}

export default ToastMessageStore;
